import { useRef, useState } from "react";

import { toastify } from "@helpers/toast";
import { validateContractFile } from "../misc/helpers";

// Keeps the drag/pick plumbing out of the view: one hidden input, drag
// highlighting, and client-side validation before anything is sent.
const useContractDropzone = ({ onFile, disabled = false }) => {
    const inputRef = useRef(null);
    const [dragActive, setDragActive] = useState(false);

    const handleFiles = (fileList) => {
        const file = Array.from(fileList || [])[0];
        if (!file) return;

        const error = validateContractFile(file);
        if (error) {
            toastify({ title: error, type: "error" });
            return;
        }
        onFile(file);
    };

    const openPicker = () => {
        if (disabled) return;
        inputRef.current?.click();
    };

    const inputProps = {
        ref     : inputRef,
        type    : "file",
        onChange: (e) => {
            handleFiles(e.target.files);
            // Reset so picking the same filename again still fires onChange.
            e.target.value = "";
        }
    };

    const dropProps = {
        onDragOver: (e) => {
            if (disabled) return;
            e.preventDefault();
            setDragActive(true);
        },
        onDragLeave: () => setDragActive(false),
        onDrop     : (e) => {
            e.preventDefault();
            setDragActive(false);
            if (disabled) return;
            handleFiles(e.dataTransfer.files);
        }
    };

    return { dragActive, openPicker, inputProps, dropProps };
};

export default useContractDropzone;
